import { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import WorldPrimary from '../../../assets/world-primary.svg?react'
import CheckOrderingIcon from '../../../assets/ordering-checked.svg?react'
import UncheckOrderingIcon from '../../../assets/ordering-unchecked.svg?react'
import classNames from 'classnames'
import styles from './ModalLanguage.module.css'
import { useLocation, useNavigate } from 'react-router-dom'
import { useLingue } from '../../../hooks/languages'
import { useAuthUser } from 'use-eazy-auth'

function getPathnameWithLang(pathname: string, lang: string) {
  const nextLang = lang.toLowerCase()
  const segments = pathname.split('/').filter(Boolean)

  if (segments.length === 0) {
    return `/${nextLang}`
  }

  return `/${[nextLang, ...segments.slice(1)].join('/')}`
}

export default function ModalLanguage({
  modalLang,
  setModalLang,
}: {
  modalLang: boolean
  setModalLang: (modalLang: boolean) => void
}) {
  const { t, i18n } = useTranslation()
  const [lang, setLang] = useState(i18n.language)
  const navigate = useNavigate()
  const { pathname, search } = useLocation()
  const { data: lingue, refetch: refetchLingue } = useLingue()
  const userData = useAuthUser()
  const user = userData?.user

  useEffect(() => {
    refetchLingue()
  }, [user, refetchLingue])

  return (
    <Modal show={modalLang} onHide={() => setModalLang(false)} centered>
      <Modal.Body className={styles.ModalBody}>
        <div className={styles.TitleModal}>
          <WorldPrimary className="me-2" /> {t('SEL_LAN_SELECT_LANGUAGE')}
        </div>
        <div className={styles.DescriptionModal}>{t('SEL_LAN_TEXT_HINT')}</div>
        <div className={styles.ListOrderingItems}>
          {lingue?.map((lingua) => (
            <div
              key={lingua.id}
              className={classNames(styles.OrderingItem, {
                [styles.OrderingItemActive]:
                  lang.toLowerCase() === lingua.code.toLowerCase(),
              })}
              onClick={() => {
                setLang(lingua.code.toLowerCase())
              }}
            >
              <div>
                {lang.toLowerCase() === lingua.code.toLowerCase() ? (
                  <CheckOrderingIcon />
                ) : (
                  <UncheckOrderingIcon />
                )}
              </div>
              <div className={styles.OrderingItemTitle}>{lingua.name}</div>
            </div>
          ))}
        </div>
        <div className="mt-4">
          <button
            className={styles.ButtonConfirm}
            onClick={() => {
              i18n.changeLanguage(lang)
              const url = `${getPathnameWithLang(pathname, lang)}${search}`
              navigate(url)
              setModalLang(false)
            }}
          >
            {t('GENERIC_CONTINUE')}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  )
}
